var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.isDialogVisible,
            title: "Cài đặt thời gian hết hạn ghim",
            width: "500px",
            "panel-icon": "el-icon-time",
            "panel-title": "Thiết lập ngày bỏ ghim",
            "panel-subtitle": "Tin ghim sẽ tự động hết hạn theo ngày bạn chọn",
          },
          on: { "update:visible": _vm.handleVisibleUpdate },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "margin-top": "10px",
                "margin-bottom": "30px",
              },
            },
            [
              _c("span", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v("\n        Ngày hết hạn:\n      "),
              ]),
              _c(
                "div",
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "Chọn ngày bỏ ghim",
                      format: "dd-MM-yyyy",
                      "value-format": "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions,
                      clearable: false,
                    },
                    model: {
                      value: _vm.initialData.endPinDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.initialData, "endPinDate", $$v)
                      },
                      expression: "initialData.endPinDate",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer sk-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: { click: _vm.handleConfirm },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _vm._v("\n        Lưu\n      "),
                ]
              ),
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.clickBtnClose } },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v("\n        Đóng\n      "),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }